// Header, sidebar, and top-level navigation.
const layout = {
  en: {
    'layout.month': 'Month',
    'layout.yearShort': 'Year',
    'layout.week': 'Week',
    'layout.monthView': 'Month view',
    'layout.weekView': 'Week view',
    'layout.previousMonth': 'Previous month',
    'layout.nextMonth': 'Next month',
    'layout.previousWeek': 'Previous week',
    'layout.nextWeek': 'Next week',
    'layout.planBedsByYear': 'Plan beds by year',
    'layout.careGuide': 'Care guide for common crops',
    'layout.menu': 'Menu',
    'layout.openMenu': 'Open menu',
    'layout.plantManagement': 'Plant Management',
    'layout.managePlants': 'Manage Plants',
    'layout.todoManagement': 'To-do Management',
    'layout.manageTodo': 'Manage to-do',
    'layout.gardenPlanner': 'Garden Planner',
    'layout.vegetableGuide': 'Vegetable Guide',
    'layout.diseaseGuide': 'Disease Guide',
    'layout.profile': 'Account',
    'layout.calendar': 'Calendar',
    'layout.yearLabel': 'Year {year}',
    'layout.monthViewNamed': 'Month view — {month}',
    'layout.backToCalendar': 'Back to calendar',
    'layout.calendarView': 'Calendar view',
  },
  lt: {
    'layout.month': 'Mėnuo',
    'layout.yearShort': 'Metai',
    'layout.week': 'Savaitė',
    'layout.monthView': 'Mėnesio vaizdas',
    'layout.weekView': 'Savaitės vaizdas',
    'layout.previousMonth': 'Ankstesnis mėnuo',
    'layout.nextMonth': 'Kitas mėnuo',
    'layout.previousWeek': 'Ankstesnė savaitė',
    'layout.nextWeek': 'Kita savaitė',
    'layout.planBedsByYear': 'Planuokite lysves pagal metus',
    'layout.careGuide': 'Populiarių augalų priežiūros gidas',
    'layout.menu': 'Meniu',
    'layout.openMenu': 'Atidaryti meniu',
    'layout.plantManagement': 'Augalų valdymas',
    'layout.managePlants': 'Tvarkyti augalus',
    'layout.todoManagement': 'Darbų valdymas',
    'layout.manageTodo': 'Tvarkyti darbus',
    'layout.gardenPlanner': 'Daržo planuoklė',
    'layout.vegetableGuide': 'Daržovių gidas',
    'layout.diseaseGuide': 'Ligų gidas',
    'layout.profile': 'Paskyra',
    'layout.calendar': 'Kalendorius',
    'layout.yearLabel': '{year} m.',
    'layout.monthViewNamed': 'Mėnesio vaizdas — {month}',
    'layout.backToCalendar': 'Grįžti į kalendorių',
    'layout.calendarView': 'Kalendoriaus vaizdas',
  },
};

export default layout;
